import parse from "html-react-parser"
import { verifyIntendedPromiseRejection } from "./utils/modal_promise"
import classNames from "classnames"

import plusIcon from "images/icons/plus.svg?raw"
import minusIcon from "images/icons/minus.svg?raw"
import styles from "./diy_add_tanda_button.module.scss"

interface Props {
  allowNewBadge?: string
  anchorTitle: string
  collapse?: boolean
  onClick: () => void
}

export default function DIYAddTandaButton({ allowNewBadge, anchorTitle, collapse = false, onClick }: Props) {
  return (
    <button
      type="button"
      className={classNames(styles.add, "plus-icon-button")}
      onClick={verifyIntendedPromiseRejection(onClick)}
      title={anchorTitle}
      aria-label={anchorTitle}
      data-allow-new-badge={allowNewBadge}
    >
      <span>{parse(collapse ? minusIcon : plusIcon)}</span>
    </button>
  )
}
